import React from "react";
import { useState } from "react";
import "../../style/portfolio.css";
import movieDesktop from "../../images/movieDesktop.jpg";
import movieMobile from "../../images/movieMobile.jpg";

const MovieApp = () => {
  const [desktop, setDesktop] = useState(true);
  const desktopImg = () => {
    setDesktop(true);
  };
  const mobileImg = () => {
    setDesktop(false);
  };
  return (
    <div className="portfolio-element">
      <div className="portfolio-left">
        <img src={desktop ? movieDesktop : movieMobile} alt="movie app demo" />
        <br />
        <button
          className={desktop ? "btn-active" : "btn-inactive"}
          onClick={desktopImg}
        >
          DISEÑO DESKTOP
        </button>
        <button
          className={desktop ? "btn-inactive" : "btn-active"}
          onClick={mobileImg}
        >
          DISEÑO MOVIL
        </button>
      </div>
      <div className="portfolio-right">
        <h1 className="headings-portfolio">Movie App</h1>
        <p>
          Realización de página web de un catálogo de películas y series
          realizado en React consumiendo la API de TheMovieDB. Este proyecto
          incluye la funcionalidad de filtrar las películas o las series por
          temporadas, en la que el usuario también puede seleccionar el género
          de la película. Con este proyecto, aprendí algo nuevo y me ayudó a
          mejorar mi habilidad como programador y definir mi estilo.
        </p>
        <a target="blank" href="https://movieapp-dev-vikas.netlify.app/">
          <button className="btn-visitar">Ver proyecto</button>
        </a>
        <a target="blank" href="https://github.com/khanchandanivikas/movieApp">
          <button className="btn-visitar">Ver codigo</button>
        </a>
      </div>
    </div>
  );
};

export default MovieApp;
